import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  listRegistryFleets,
  parseTokenClaims,
  RegistryFleet,
  upsertRegistryFleet,
} from "../api";

export function FleetsPage() {
  const { t, i18n } = useTranslation(["dashboard", "common"]);
  const claims = parseTokenClaims();
  const myFirm = claims?.firm_id ?? "";
  const [fleets, setFleets] = useState<RegistryFleet[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState("");
  const [name, setName] = useState("");

  async function refresh() {
    try {
      setFleets(await listRegistryFleets(myFirm));
      setError(null);
    } catch (exc) {
      setError(String(exc));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onCreate(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    try {
      await upsertRegistryFleet({ id, firm_id: myFirm, name });
      setId("");
      setName("");
      refresh();
    } catch (exc) {
      setError(String(exc));
    }
  }

  return (
    <div className="page">
      <h2>{t("fleets.title")}</h2>
      <p className="muted">{t("common:shell.firm", { id: myFirm || t("fleets.noJwt") })}</p>
      {error && <p className="error">{error}</p>}

      <form onSubmit={onCreate} className="row-form">
        <input
          placeholder={t("fleets.idPlaceholder")}
          value={id}
          onChange={(e) => setId(e.target.value)}
          required
        />
        <input
          placeholder={t("fleets.namePlaceholder")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <button type="submit">{t("common:actions.createUpdate")}</button>
      </form>

      {loading ? (
        <p>{t("common:actions.loading")}</p>
      ) : fleets.length === 0 ? (
        <p>{t("fleets.empty")}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{t("fleets.th.id")}</th>
              <th>{t("fleets.th.name")}</th>
              <th>{t("fleets.th.created")}</th>
            </tr>
          </thead>
          <tbody>
            {fleets.map((f) => (
              <tr key={f.id}>
                <td>{f.id}</td>
                <td>{f.name}</td>
                <td>{new Date(f.created_at).toLocaleString(i18n.resolvedLanguage)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
